import {Platform} from 'react-native';
import Auth0, {Credentials} from 'react-native-auth0';
import {Auth0Client} from '@auth0/auth0-spa-js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Settings from '../Settings';

let mobileAuth0Client = new Auth0({
  domain: Settings.auth0.PROD.domain,
  clientId: Settings.auth0.PROD.clientId,
});

let webAuth0Client: Auth0Client | null = null;

export const changeAuth0Client = (config: string) => {
  if (!config) {
    return;
  }
  if (Platform.OS === 'web') {
    webAuth0Client = new Auth0Client({
      domain: Settings.auth0[config].domain,
      clientId: Settings.auth0[config].clientIdAuth0Web,
      authorizationParams: {
        redirect_uri: window.location.origin,
        organization: Settings.auth0[config].orgIdAuth0,
        audience: Settings.auth0[config].audience,
        scope: Settings.scope,
      },
      useRefreshTokens: true,
      cacheLocation: 'localstorage',
    });
  } else {
    mobileAuth0Client = new Auth0({
      domain: Settings.auth0[config].domain,
      clientId: Settings.auth0[config].clientId,
    });
  }
};

export const getMobileAuth0Client = () => {
  return mobileAuth0Client;
};

export const getWebAuth0Client = () => {
  if (!webAuth0Client) {
    webAuth0Client = new Auth0Client({
      domain: Settings.auth0.PROD.domain,
      clientId: Settings.auth0.PROD.clientIdAuth0Web,
      authorizationParams: {
        redirect_uri: window.location.origin,
        organization: Settings.auth0.PROD.orgIdAuth0,
        audience: Settings.auth0.PROD.audience,
        scope: Settings.scope,
      },
      useRefreshTokens: true,
      cacheLocation: 'localstorage',
    });
  }
  return webAuth0Client;
};

const OLD_STORAGE_KEY = '@auth_session';

export async function migrateOldSessionIfNeeded(): Promise<void> {
  if (Platform.OS === 'web') {
    return;
  }

  const auth0Client = getMobileAuth0Client();
  const alreadyValid =
    await auth0Client.credentialsManager.hasValidCredentials();
  if (alreadyValid) {
    return;
  }

  const oldSessionStr = await AsyncStorage.getItem(OLD_STORAGE_KEY);
  if (!oldSessionStr) {

    return;
  }

  let oldSession: {
    accessToken: string | null;
    refreshToken: string | null;
    idToken: string | null;
    email: string | null;
    accountId: string | null;
    expiresAt: number;
    isSSO: boolean;
    isNewUser: boolean | null;
    hasQRCode: boolean | null;
  };

  try {
    oldSession = JSON.parse(oldSessionStr);

  } catch (error) {

    return;
  }

  if (!oldSession.accessToken || !oldSession.idToken) {

    return;
  }

  const newCreds: Credentials = {
    accessToken: oldSession.accessToken,
    idToken: oldSession.idToken,
    refreshToken: oldSession.refreshToken || '',
    expiresAt: oldSession.expiresAt || 0,
    tokenType: 'Bearer',
    scope: 'openid profile email',
  };

  try {
    await auth0Client.credentialsManager.saveCredentials(newCreds);
  } catch (err) {

    return;
  }

  await AsyncStorage.removeItem(OLD_STORAGE_KEY);

}
